import React from 'react';
import styled from 'styled-components';

import usestorage from 'app/utils/storage';
import { useOffers } from 'features/offers';
import { Button, ButtonIcon, Flex } from 'components';
import { AuthLoginBox } from 'features/auth/components';

const storage = usestorage('sessionStorage');

const LoginCloseButton = styled(ButtonIcon)`
  position: absolute;
  top: 20px;
  right: 20px;
`;

const PaymentLogin = () => {
  const { showLogin, setLogin, hasAccount } = useOffers();

  const handleCloseLogin = () => {
    storage.remove('redirect_url');
    setLogin({ bypassLogin: true, showLogin: false });
  };

  return (
    <>
      {showLogin && (
        <Flex position="fixed" width="100vw" height="100vh" top={0} left={0} bg="black50" zIndex={100} alignItems="center" justifyContent="center">
          <Flex width="100%" maxWidth={{ m: '80%', t: 480 }} mx={{ m: 20 }} flexDirection="column" position="relative">
            <LoginCloseButton icon="close" onClick={handleCloseLogin} bg="transparent" color="primary_400" colorHover="primary_200" iconWidth={22} />
            <AuthLoginBox description={hasAccount ? 'Por favor, preencha abaixo seu e-mail e sua senha.' : ''} isOffer showRegisterLink={false} />

            <Button onClick={handleCloseLogin} square bg="transparent" mt={2}>
              Comprar sem logar
            </Button>
          </Flex>
        </Flex>
      )}
    </>
  );
};

export default PaymentLogin;
